import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Applicationroute from './containers/Applicationroute';
import 'antd/dist/antd.css';
// import App from './containers/App';
// import reportWebVitals from './reportWebVitals';
// import Card from './Card';
// import CardList from './CardList';
import 'tachyons';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';



ReactDOM.render(
  <React.StrictMode>
    <Applicationroute/> 
  </React.StrictMode>,
  document.getElementById('mago')
);
serviceWorkerRegistration.register();


// ReactDOM.render(
//   <React.StrictMode>
//     <div>
//       <Card name={robots[0].name} email ={robots[0].email} username ={robots[0].username} id ={robots[0].id}/>
//       <Card name={robots[1].name} email ={robots[1].email} username ={robots[1].username} id ={robots[1].id}/>
//       <Card name={robots[2].name} email ={robots[2].email} username ={robots[2].username} id ={robots[2].id}/>
//       <Card name={robots[3].name} email ={robots[3].email} username ={robots[3].username} id ={robots[3].id}/>
//       <Card name={robots[4].name} email ={robots[4].email} username ={robots[4].username} id ={robots[4].id}/>      
//     </div>
//   </React.StrictMode>,
//   document.getElementById('mago')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


//First APP
// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// // import App from './App';
// import reportWebVitals from './reportWebVitals';
// import Hello from './Hello';
// import Hello2 from './Hello2';
// import 'tachyons';

// ReactDOM.render(
//   <React.StrictMode>
//     <Hello properties1 = {'Manager of the Club of 16'}  properties2 = {'Chairman of the Club of 32'}/>
//     <Hello2 value ={'Dont do that'} />
//   </React.StrictMode>,
//   // <React.StrictMode>
//   //  <h1>welcome to welcome</h1>
//   // </React.StrictMode>,
//   document.getElementById('mago')
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();